

































import { Component, Vue, Watch } from "vue-property-decorator";
import ProjectTemplateTask from "../models/project-template-task";
import { addDays, endOfDay } from "date-fns";
import VTaskSubtaskControl from "@/components/task/VTaskSubtaskControl.vue";

interface TaskSubData {
  id: number;
  name: string;
  start: string | Date;
  end: Date;
  duration: number;
  subTasks: any[];
}

@Component({
  components: {
    VTaskSubtaskControl
  }
})
export default class PlanTaskEditModal extends Vue {
  task: TaskSubData = {
    id: 0,
    name: "",
    start: new Date() as string | Date,
    end: new Date(),
    duration: 1,
    subTasks: []
  };
  hasSubTasks: boolean = false;

  oldSubtasks = [
    {
      id: 0,
      name: ""
    }
  ] as object[];

  @Watch("hasSubTasks")
  private initSubTask(hasSubTasks: boolean) {
    if (!hasSubTasks) {
      return this.$set(this.task, "subTasks", []);
    }

    if (!this.task.subTasks || !Object.keys(this.task.subTasks).length) {
      return this.$set(this.task, "subTasks", this.oldSubtasks);
    }
    this.$nextTick(() => {
      this.$refs.subtasks &&
        (this.$refs.subtasks as VTaskSubtaskControl).focus();
    });
  }

  public show(task: ProjectTemplateTask) {
    this.task = task as TaskSubData;
    if (task.subTasks && task.subTasks.length) {
      this.oldSubtasks = task.subTasks;
      this.hasSubTasks = true;
    } else {
      this.oldSubtasks = [
        {
          id: 0,
          name: ""
        }
      ];
      this.hasSubTasks = false;
    }
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  okTitle = "保存";

  get cancelTitle() {
    if (this.task.id) {
      return "削除";
    } else {
      return "キャンセル";
    }
  }

  get cancelVariant() {
    if (this.task.id) {
      return "danger";
    } else {
      return "secondary";
    }
  }

  get duration() {
    return this.task.duration;
  }

  set duration(duration: number) {
    this.task.duration = duration;
    this.task.end = endOfDay(addDays(this.task.start as Date, duration - 1));
  }

  submit() {
    this.$emit("submit", this.task);
  }

  cancel() {
    if (this.task.id) {
      this.$emit("delete", this.task);
    }
  }
}
